<div class="vtr-ui-hyperlink-button">
	<div class="hyperlink-box"
		[ngClass]="{'disabled': isDisabled === true}">
		<button
			(click)="onClick()"
			[tabindex]="tabIndex ? tabIndex : 0"
			[disabled]="isDisabled"
			class="hyperlink-outline"
			[attr.role]="linkRole"
			[attr.id]="linkId"
			[attr.aria-label]="ariaLabel"
			[matTooltip]=" disableTooltip ? '' : tooltipText "
			matTooltipClass="vtr-system-tooltip">
			<div class="hyperlink-text-container" [ngClass]="{'hyperlink-disabled': isDisabled === true}">
				<span
				class="hyperlink {{hyperlinkStyle}}"
				[innerHTML]="label"
				[ngClass]="{
					'text-upper-case': upperCaseLabel === true,
					'text-capitalize': capitalizeLabel === true
				}">
				</span>
			</div>
			<fa-icon [icon]="faIcon" *ngIf="faIcon" class="icon {{faIconStyle}}"></fa-icon>
			<img [src]='imgIconSrc | svgInline | async' role="img" class="icon image-icon" *ngIf="imgIconSrc"/>
		</button>
	</div>
</div>
